// `os.homedir()` follows $HOME, as Node's does, so the demo can run a command "on the CI runner".
export const homedir = (): string => process.env["HOME"] ?? "/home/demo"
export const tmpdir = (): string => "/tmp"
export const platform = (): string => "linux"
export const EOL = "\n"
export default { homedir, tmpdir, platform, EOL }
